import { render, staticRenderFns } from "./UserRecords.vue?vue&type=template&id=3caff922&scoped=true"
import script from "./UserRecords.vue?vue&type=script&lang=js"
export * from "./UserRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caff922",
  null
  
)

export default component.exports